import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import customerService from '../services/customerService';

export const useCustomerSearch = (initialSearch = '') => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(initialSearch);
  const [isSearching, setIsSearching] = useState(false);

  const fetchCustomers = useCallback(async (search = '') => {
    try {
      setLoading(true);
      setIsSearching(!!search);
      
      const filters = { is_active: true };
      
      if (search) {
        filters.company_name = search;
      }
      
      const response = await customerService.getCustomers({ 
        limit: 1000,
        filters: filters
      });
      
      const customersData = response.data || [];
      setCustomers(customersData);
      return customersData;
    } catch (error) {
      console.error('Error fetching customers:', error);
      message.error('Failed to load customers');
      setCustomers([]);
      return [];
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  }, []);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm !== undefined) {
        fetchCustomers(searchTerm);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm, fetchCustomers]);

  return {
    customers,
    loading,
    searchTerm,
    isSearching,
    setSearchTerm,
    fetchCustomers
  };
};
